module.exports = __webpack_public_path__ + "static/img/fundibeq_premio.4097b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion/fundibeq_premio.jpg
// module id = 5Ifx
// module chunks = 0